import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";

import { Media } from "components/Media";
import Button from "components/Button";
import PhotoCredit from 'components/PhotoCredit';
import css from "./SectionMenuBlock.module.scss";
import Icon from "components/Icon";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import { THEMES } from 'constants/buttonThemes';
import { INTROTHEMES, getIntroThemeClassNames } from 'constants/introThemes';
import FitText from "components/FitText/FitText";

class SectionMenuBlock extends React.Component {
    static propTypes = {
        longDescription: PropTypes.string,
        photoCredit: PropTypes.shape(PhotoCredit.propTypes),
        backgroundVideo: Media && Media.propTypes.video,
        backgroundImage: Media && Media.propTypes.image,
        backgroundImageMobile: Media && Media.propTypes.imageMobile,
        icon: PropTypes.string,
        header: PropTypes.string.isRequired,
        size: PropTypes.string,
        menuItems: PropTypes.array,
        breadcrumb: PropTypes.array,
        menuTitle: PropTypes.string,
        menuButtonsTheme: PropTypes.oneOf(Object.keys(THEMES).map(s => THEMES[s])),
        introTheme: PropTypes.oneOf(Object.keys(INTROTHEMES).map(s => INTROTHEMES[s])),
    };

    static defaultProps = {
        menuButtonsTheme: THEMES.yellow,
        introTheme: INTROTHEMES.grey
    }

    render() {
        const {
            longDescription,
            backgroundVideo,
            backgroundImage,
            backgroundImageMobile,
            icon,
            header,
            size,
            menuItems,
            breadcrumb,
            menuTitle,
            menuButtonsTheme,
            introTheme,
            photoCredit
        } = this.props;

        return (
            <div>
                <div
                    className={cn(css[size], css["header"], {
                        [css["background-image"]]:
                            backgroundVideo || backgroundImage,
                        [css["solid"]]: !backgroundImage,
                        [css.whiteIntro]: introTheme === INTROTHEMES.white
                    })}
                >
                    {/* BE: Mobile image recommended size is 768x1044px */}
                    {/* BE: Mobile video recommended size is 374x720px */}
                    <Media
                        image={backgroundImage}
                        imageMobile={backgroundImageMobile}
                        video={backgroundVideo}
                        alt={header}
                        theme={Media.themes.full}
                        gradient={Media.gradients.section}
                        className={backgroundImageMobile ? "media--has-mobile-image" : "media--no-mobile-image"}
                    />
                    <div className={css["inner"]}>
                        <div className={css["content-top"]}>
                            {size === "small" && <Breadcrumbs items={breadcrumb} />}
                            {icon && size === "large" && (
                                <Icon icon={icon} className={css["icon"]} />
                            )}
                            {header && <h1><FitText text={header} /></h1>}
                            {size === "small" && (
                                <div>
                                    {menuItems && (
                                        <ul className={css["buttons"]}>
                                            {menuItems.map((button, index) => (
                                                <li key={index}>
                                                    {button.url &&
                                                    button.linkText ? (
                                                            <Button
                                                                {...{tertiary : menuButtonsTheme === THEMES.yellow}}
                                                                {...{blue : menuButtonsTheme === THEMES.blue}}
                                                                className="btn--in-section-menu-block"
                                                                href={button.url}
                                                            >
                                                                {button.linkText}
                                                            </Button>
                                                        ) : (
                                                            ""
                                                        )}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            )}
                        </div>
                        {size === "large" && (
                            <div className={css["buttons-header"]}>
                                {menuTitle}
                            </div>
                        )}
                    </div>
                    {size === "large" && (
                        <div>
                            {menuItems && (
                                <div className={css["content-bottom"]}>
                                    <ul className={css["buttons"]}>
                                        {menuItems.map((button, index) => (
                                            <li key={index}>
                                                {button.url &&
                                                button.linkText ? (
                                                        <Button
                                                            {...{tertiary : menuButtonsTheme === THEMES.yellow}}
                                                            {...{blue : menuButtonsTheme === THEMES.blue}}
                                                            className="btn--in-section-menu-block"
                                                            href={button.url}
                                                        >
                                                            {button.linkText}
                                                        </Button>
                                                    ) : (
                                                        ""
                                                    )}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                    )}
                </div>
                <div
                    className={cn(css.text, getIntroThemeClassNames(css, introTheme))}
                >
                    {photoCredit && 
                        <div className={css.photoCreditContainer}>
                            <PhotoCredit {...photoCredit} className={css.photoCredit} />
                        </div>
                    }
                    {longDescription && (
                        <div
                            className={css.description}
                            dangerouslySetInnerHTML={{
                                __html: longDescription
                            }}
                        />
                    )}
                </div>
            </div>
        );
    }
}

export default SectionMenuBlock;


// WEBPACK FOOTER //
// ./src/components/SectionMenuBlock/SectionMenuBlock.jsx